const MEGA_BYTE = 1024 * 1024;
const maxAssetSize = {
    dishPlaceholder: 20 * MEGA_BYTE,
};

const validateFileSize = (file, key) => {
    if (file) {
        if (file.size > maxAssetSize[key]) {
            throw `File is bigger than the allowed size (${maxAssetSize[key] / MEGA_BYTE}MB)`;
        }
    }
};

module.exports = {
    validateFileSize
};
